import { AxiosError } from 'axios';

// Use environment variable with fallback to production URL
export const serverUrl = process.env.REACT_APP_API_URL || 'https://api.astrologys.ai';

export const handleAxiosError = (error: AxiosError): never => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const message = (error.response.data as { detail: string }).detail || 'An error occurred';
    throw new Error(message);
  } else if (error.request) {
    // The request was made but no response was received
    throw new Error('No response received from server');
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new Error(error.message);
  }
}; 